(function () {
  // Ensure global namespace
  window.AutoGWP = window.AutoGWP || {};
  var AutoGWP = window.AutoGWP;

  AutoGWP.debug = false; // turn false once you're happy
  AutoGWP._suspendHook = false;
  AutoGWP._isRunning = false;
  AutoGWP._productTagCache = AutoGWP._productTagCache || {};

  function log() {
    if (!AutoGWP.debug) return;
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[AutoGWP]'].concat(args));
  }

  // ---------------------------
  //  API: add/remove free gift
  // ---------------------------

  AutoGWP.add = function (variantId) {
    log('Adding free gift variant', variantId);

    AutoGWP._suspendHook = true;

    var body = {
      id: variantId,
      quantity: 1,
      properties: {
        _free_gift: 'true' // marker so we can detect it later
      }
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) {
          log('AutoGWP.add error', response.status, response.statusText);
        }
        return response;
      })
      .catch(function (error) {
        console.error('[AutoGWP] add failed', error);
      })
      .finally(function () {



AutoGWP._suspendHook = false;



// trigger Shopify function again
setTimeout(function(){



console.log("Re-running Shopify Function after free gift added");



fetch('/cart/update.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify({})
});



},500);



});
  };

  AutoGWP.remove = function (variantId) {
    log('Removing free gift variant', variantId);

    AutoGWP._suspendHook = true;

    var body = {
      id: String(variantId),
      quantity: 0
    };

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) {
          log('AutoGWP.remove error', response.status, response.statusText);
        }
        return response;
      })
      .catch(function (error) {
        console.error('[AutoGWP] remove failed', error);
      })
      .finally(function () {
        AutoGWP._suspendHook = false;
      });
  };

  // ---------------------------
  //  Refresh cart drawer HTML
  // ---------------------------

  function refreshCartDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        log('No <cart-drawer> element found, skipping refresh');
        return;
      }

      var sectionId = drawer.getAttribute('data-id');
      if (!sectionId) {
        log('cart-drawer has no data-id attribute, skipping refresh');
        return;
      }

      var url =
        window.location.pathname +
        '?section_id=' +
        encodeURIComponent(sectionId);

      log('Refreshing cart drawer from section URL:', url);

      fetch(url, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;

          var newDrawer = tmp.querySelector('cart-drawer');
          if (!newDrawer) {
            log('No <cart-drawer> in section response, nothing to replace');
            return;
          }

          drawer.innerHTML = newDrawer.innerHTML;
          log('Cart drawer refreshed from section HTML');
        })
        .catch(function (err) {
          console.error('[AutoGWP] Drawer refresh error', err);
        });
    } catch (e) {
      console.error('[AutoGWP] Drawer refresh outer error', e);
    }
  }

  // ---------------------------
  //  Apply actions (add/remove)
  // ---------------------------

  AutoGWP.modifyCart = function (actions) {
    if (!actions || !actions.length) {
      log('modifyCart called with no actions');
      return;
    }

    log('Modifying cart with actions', actions);

    AutoGWP._suspendHook = true;

    var promises = actions.map(function (item) {
      if (item.status === 'valid') {
        return AutoGWP.add(item.id);
      }
      if (item.status === 'invalid') {
        return AutoGWP.remove(item.id);
      }
      return Promise.resolve();
    });

    return Promise.all(promises)
      .then(function () {
        // After we've finished changing the cart, refresh the drawer UI
        refreshCartDrawer();

        // On the full cart page, reload so the liquid cart table stays in sync
        try {
          if (
            document.body &&
            document.body.classList.contains('template-cart')
          ) {
            log('On cart template – reloading page to sync line items');
            window.location.reload();
          }
        } catch (e) {
          console.error('[AutoGWP] Error while checking/reloading cart page', e);
        }
      })
      .catch(function (err) {
        console.error('[AutoGWP] modifyCart error', err);
      })
      .finally(function () {
        AutoGWP._suspendHook = false;
      });
  };

  // ---------------------------
  //  Helper: fetch product tags
  // ---------------------------

  function fetchTagsForHandles(handles) {
    var unique = [];
    var seen = {};

    handles.forEach(function (h) {
      if (!h) return;
      var key = h.toLowerCase();
      if (!seen[key] && !AutoGWP._productTagCache[key]) {
        seen[key] = true;
        unique.push(key);
      }
    });

    if (!unique.length) {
      return Promise.resolve();
    }

    log('Fetching product tags for handles:', unique);

    var promises = unique.map(function (handle) {
      var url = '/products/' + encodeURIComponent(handle) + '.js';

      return fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          if (!res.ok) {
            log('Failed to fetch product JSON for', handle, res.status);
            return null;
          }
          return res.json();
        })
        .then(function (product) {
          var tags = [];
          if (product && Array.isArray(product.tags)) {
            tags = product.tags.map(function (t) {
              return String(t).toLowerCase();
            });
          }
          AutoGWP._productTagCache[handle] = tags;
          log('Cached tags for', handle, tags);
        })
        .catch(function (err) {
          console.error('[AutoGWP] product tags fetch error for', handle, err);
          AutoGWP._productTagCache[handle] = [];
        });
    });

    return Promise.all(promises);
  }

  // ---------------------------
  //  Core: compare rules vs cart
  // ---------------------------

  AutoGWP.run = function () {
    var config = window.AutoGWPConfig || {};
    var rules = config.rules || [];

    if (!rules.length) {
      log('No rules configured or AutoGWPConfig missing, skipping');
      return;
    }

    if (AutoGWP._isRunning) {
      log('Already running, skipping');
      return;
    }

    AutoGWP._isRunning = true;
    log('Running AutoGWP check with rules:', rules);

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        log('Cart state from /cart.js:', cart);

        if (!cart || !cart.items || !cart.items.length) {
          log('Cart empty, nothing to do');
          return;
        }

        var items = cart.items;
        var handles = items.map(function (item) {
          return (item.handle || '').toLowerCase();
        });

        return fetchTagsForHandles(handles).then(function () {
          var actions = [];

          rules.forEach(function (rule, idx) {
            if (!rule || !rule.vid || !rule.tag) return;

            var tag = String(rule.tag).toLowerCase();
            var requiredQty = parseInt(rule.qty, 10) || 1;
            var variantId = parseInt(rule.vid, 10);

            var count = 0;
            var giftInCart = false;

            items.forEach(function (item) {
              var handle = (item.handle || '').toLowerCase();
              var qty = item.quantity || 0;
              var tags = AutoGWP._productTagCache[handle] || [];

              if (tags.indexOf(tag) !== -1) {
                count += qty;
              }

              if (item.variant_id === variantId) {
                var freeGift = false;
                if (item.properties) {
                  for (var key in item.properties) {
                    if (
                      !Object.prototype.hasOwnProperty.call(
                        item.properties,
                        key
                      )
                    ) {
                      continue;
                    }
                    if (String(key).indexOf('_free_gift') !== -1) {
                      freeGift = true;
                      break;
                    }
                  }
                }
                if (freeGift) {
                  giftInCart = true;
                }
              }
            });

            var qualifies = count >= requiredQty;

            log(
              'Rule',
              idx + 1,
              'tag:',
              tag,
              '| qty needed:',
              requiredQty,
              '| qty found:',
              count,
              '| giftInCart:',
              giftInCart
            );

            if (qualifies && !giftInCart) {
              log('→ Should add gift variant', variantId);
              actions.push({ id: variantId, status: 'valid' });
            } else if (!qualifies && giftInCart) {
              log('→ Should remove gift variant', variantId);
              actions.push({ id: variantId, status: 'invalid' });
            }
          });

          if (actions.length) {
            return AutoGWP.modifyCart(actions);
          } else {
            log('No actions needed after evaluating rules');
          }
        });
      })
      .catch(function (err) {
        console.error('[AutoGWP] run error', err);
      })
      .finally(function () {
        AutoGWP._isRunning = false;
      });
  };

  // ---------------------------
  //  Hook into fetch for cart
  // ---------------------------

  var cartEndpointRegex = /\/cart(\/add|\/change|\/update)(\.js)?(\?|$)/;

  if (window.fetch && !window.__AutoGWPPatchedFetch) {
    window.__AutoGWPPatchedFetch = true;

    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';

      var isCartEndpoint = cartEndpointRegex.test(url);

      return originalFetch(input, init).then(function (response) {
        if (
          isCartEndpoint &&
          response &&
          response.ok &&
          !AutoGWP._suspendHook
        ) {
          log('Fetch cart endpoint called:', url, '→ scheduling AutoGWP.run()');
          setTimeout(function () {
            try {
              AutoGWP.run();
            } catch (e) {
              console.error('[AutoGWP] fetch hook run error', e);
            }
          }, 0); // no extra delay
        }

        return response;
      });
    };

    log('Patched window.fetch for cart add/change/update endpoints');
  }

  // ---------------------------
  //  Hook into XHR for cart
  // ---------------------------

  if (window.XMLHttpRequest && !window.__AutoGWPPatchedXHR) {
    window.__AutoGWPPatchedXHR = true;

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__AutoGWPIsCart = cartEndpointRegex.test(String(url || ''));
      } catch (e) {
        this.__AutoGWPIsCart = false;
      }
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;

      if (xhr.__AutoGWPIsCart && !AutoGWP._suspendHook) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            log(
              'XHR cart endpoint responded with',
              xhr.status,
              '→ scheduling AutoGWP.run()'
            );
            setTimeout(function () {
              try {
                AutoGWP.run();
              } catch (e) {
                console.error('[AutoGWP] XHR hook run error', e);
              }
            }, 0); // no extra delay
          }
        });
      }

      return origSend.call(this, body);
    };

    log('Patched XMLHttpRequest for cart add/change/update endpoints');
  }

  // ---------------------------
  //  Run once on initial load (cart page only)
  // ---------------------------

  function onReady(fn) {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(function () {
    try {
      if (
        document.body &&
        document.body.classList.contains('template-cart')
      ) {
        setTimeout(function () {
          try {
            AutoGWP.run();
          } catch (e) {
            console.error('[AutoGWP] initial run error', e);
          }
        }, 300); // can reduce if you want
      }
    } catch (e) {
      console.error('[AutoGWP] initial run setup error', e);
    }
  });
})();
